<app-tos-acceptance />
<div class="flex h-screen overflow-hidden" style="background: var(--nexus-bg);">

  @if (!layout.isMobile()) {
    <app-sidebar />
  }

  <!-- Mobile drawer - always in DOM for CSS transition; panel is positioned fixed -->
  <app-mobile-drawer />

  <div class="flex flex-col flex-1 overflow-hidden min-w-0">
    <app-topbar />
    <main class="flex-1 overflow-y-auto" [class.p-6]="!layout.isMobile()">
      <router-outlet />
    </main>
  </div>

  <app-toast-host />
</div>
<app-unexpected-error-modal />
